import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default class ContactsList extends Component {

constructor(props)
{
	console.log(props);
	super(props);

}

state =
{
		contactsObject: {},
		contacts: []
};

componentDidMount()

{

	this.handleOnLoad();

}

handleOnLoad = () => {

  axios.get(`${global.config.apiServicesUrl}/contacts??filter[where][createUser][eq]=${this.props.userId}&filter[limit]=100`).then(res => {

  const contacts = res.data;

  console.log(contacts);

  this.setState({ contacts : res.data });

  console.log(res.data[0]);

	});



}

render(){

return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
							<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Contacts
														</h3>
														<input class="form-control input-xlarge col-sm-8" placeholder="Filter" />&nbsp;
														<a class="btn btn-success" href="create-contact">Create A Contact</a>&nbsp; 
							</div>
							<br />

	<table class="oux_table table table-striped table-bordered table-hover" id="list" border="1" var="item" rows="20"  value="#{ombCustomerForm.searchResults }">

			<thead>
				<tr>
					<th scope = "col">Id</th>
					<th scope = "col">Pic</th>
					<th scope = "col">First Name</th>
					<th scope = "col">Last Name</th>
					<th scope = "col">Company</th>
					<th scope = "col">Email</th>
					<th scope = "col">Phone</th>
					<th scope = "col">City</th>
					<th scope = "col">State</th>
					<th scope = "col">Actions</th>
				</tr>
			</thead>

			<tbody>

				{this.state.contacts.map( ( {contactsId, pictureFilepath, firstName, lastName, companyName,
				email1, cellPhone, priorityCode, city,stateCode} ) => {

					return	<tr>

							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{contactsId}</Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}><img src={pictureFilepath} /></Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{firstName}</Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{lastName}</Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{companyName }</Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{email1 }</Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{cellPhone}</Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{city}</Link></td>
							<td><Link  to={{ pathname: "/manage-contact", search : `?id=${contactsId}` }}>{stateCode }</Link></td>
							<td>

										<button class="btn btn-danger" onclick="confirm('This contact will be deleted ok?')">Delete
										</button>
							</td>
						</tr>


				})
			}

			</tbody>


		</table>
											

						</div>            
					</div>		

	            </div>	
            </div>
            
			</div>
			</div>
			

);
}
}

